import { ResponsiveContainer, ComposedChart, Bar, Line, XAxis, YAxis, Tooltip, CartesianGrid } from "recharts";

const TipBox = ({ active, payload }) => {
  if (!active || !payload?.length) return null;
  const p = payload[0].payload;
  return (
    <div className="rounded-md border border-[#242C3D] bg-[#141A24] px-3 py-2 text-xs">
      <div className="font-mono text-slate-300 mb-1">Minute {p.minute}–{p.minute + 1}</div>
      <div className="text-indigo-300">{p.retention}% still watching ({p.viewers})</div>
      <div className="text-rose-300">{p.dropped} stopped here</div>
    </div>
  );
};

export const RetentionChart = ({ data }) => {
  const worst = data.reduce((a, b) => (b.dropped > (a?.dropped || 0) ? b : a), null);
  return (
    <div className="rounded-lg border border-[#242C3D] bg-[#141A24]/70 p-6 mb-8" data-testid="dropoff-chart">
      <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-2 mb-4">
        <div>
          <h3 className="font-display font-semibold">Viewer drop-off · by minute</h3>
          <p className="text-xs text-slate-500 mt-1">Line: % of viewers still watching. Bars: viewers who stopped in that minute.</p>
        </div>
        {worst && (
          <span data-testid="dropoff-biggest" className="font-mono text-xs px-3 py-1.5 rounded-full bg-rose-500/10 border border-rose-500/30 text-rose-300 self-start">
            Biggest drop: minute {worst.minute}–{worst.minute + 1} ({worst.dropped})
          </span>
        )}
      </div>
      {data.length === 0 ? (
        <p className="text-sm text-slate-500 py-10 text-center" data-testid="dropoff-empty">No viewing data yet.</p>
      ) : (
        <div className="h-64 min-h-[256px] w-full">
          <ResponsiveContainer width="100%" height={256}>
            <ComposedChart data={data}>
              <CartesianGrid stroke="#242C3D" strokeDasharray="3 3" vertical={false} />
              <XAxis dataKey="label" stroke="#64748b" fontSize={11} />
              <YAxis yAxisId="pct" domain={[0, 100]} unit="%" stroke="#64748b" fontSize={11} width={40} />
              <YAxis yAxisId="cnt" orientation="right" allowDecimals={false} stroke="#64748b" fontSize={11} width={28} />
              <Tooltip content={<TipBox />} cursor={{ fill: "rgba(255,255,255,0.03)" }} />
              <Bar yAxisId="cnt" dataKey="dropped" fill="#F43F5E" fillOpacity={0.55} radius={[3, 3, 0, 0]} maxBarSize={28} />
              <Line yAxisId="pct" type="monotone" dataKey="retention" stroke="#6366F1" strokeWidth={2.5} dot={{ r: 2.5, fill: "#6366F1" }} />
            </ComposedChart>
          </ResponsiveContainer>
        </div>
      )}
    </div>
  );
};
